export * from './aSCII.service';
import { ASCIIService } from './aSCII.service';
export * from './battleField.service';
import { BattleFieldService } from './battleField.service';
export * from './board.service';
import { BoardService } from './board.service';
export * from './civilizationBoard.service';
import { CivilizationBoardService } from './civilizationBoard.service';
export * from './engineBattle.service';
import { EngineBattleService } from './engineBattle.service';
export * from './engineCityManagement.service';
import { EngineCityManagementService } from './engineCityManagement.service';
export * from './engineCommons.service';
import { EngineCommonsService } from './engineCommons.service';
export * from './engineMovement.service';
import { EngineMovementService } from './engineMovement.service';
export * from './engineResearch.service';
import { EngineResearchService } from './engineResearch.service';
export * from './engineStartOfTurn.service';
import { EngineStartOfTurnService } from './engineStartOfTurn.service';
export * from './engineTrade.service';
import { EngineTradeService } from './engineTrade.service';
export * from './game.service';
import { GameService } from './game.service';
export * from './map.service';
import { MapService } from './map.service';
export * from './market.service';
import { MarketService } from './market.service';
export * from './rules.service';
import { RulesService } from './rules.service';
export const APIS = [ASCIIService, BattleFieldService, BoardService, CivilizationBoardService, EngineBattleService, EngineCityManagementService, EngineCommonsService, EngineMovementService, EngineResearchService, EngineStartOfTurnService, EngineTradeService, GameService, MapService, MarketService, RulesService];
